import React, { FunctionComponent, SVGProps } from "react";

export const FiltersIcon: FunctionComponent<SVGProps<SVGSVGElement>> = (
  props
) => {
  return (
    <svg
      {...props}
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M2 7.714C2 7.32 2.32 7 2.714 7h18.572a.714.714 0 1 1 0 1.429H2.714A.714.714 0 0 1 2 7.714ZM5.571 12c0-.395.32-.714.715-.714h11.428a.714.714 0 1 1 0 1.428H6.286A.714.714 0 0 1 5.57 12Zm3.572 4.286c0-.395.32-.715.714-.715h4.286a.714.714 0 0 1 0 1.429H9.857a.714.714 0 0 1-.714-.714Z"
        fill="#334155"
        fillRule="evenodd"
      />
    </svg>
  );
};
